import { buildCoverageIdsByBlock } from "./grid/buildContextMaps";
import { resolveTotalsBlockName } from "./totalsBlockName";

import type { FinancialsTableResponse } from "@platform/api";

/**
 * Names of the totals blocks — custom or default — that have no visible
 * coverages rolling up to them. A block with no visible coverages
 * contributes nothing to its premium totals, which is almost always a
 * misconfiguration the analyst should correct before presenting.
 */
export const findEmptyTotalsBlockNames = (
  payload: FinancialsTableResponse,
): string[] => {
  const coverageIdsByBlock = buildCoverageIdsByBlock(payload);

  return payload.totalsBlocks
    .filter((block) => (coverageIdsByBlock.get(block.id)?.size ?? 0) === 0)
    .map(resolveTotalsBlockName);
};
